///
/// TODO :: Need to use ENV variables here
///
function GetBuildStoryblokAccessToken() {
  if(process.env.NODE_ENV === "development") {
    return "nHctYi23dYHEej9Ps0CQwwtt"
  }
  if(process.env.CONTEXT === "branch-deploy") {
    return "nHctYi23dYHEej9Ps0CQwwtt"
  }
  return "XKPLEQCanwNeg2Pro9obvwtt"
}

function GetBridgeStoryblokAccessToken() {
  return "nHctYi23dYHEej9Ps0CQwwtt"
}

function GetBuildStoryblokVersion() {
  if(process.env.NODE_ENV === "development") {
    return "draft"
  }
  if(process.env.CONTEXT === "branch-deploy") {
    return "draft"
  }
  return "published"
}

function GetRecaptchaKey() {
  if(process.env.NODE_ENV === "development") {
    return process.env.GATSBY_RECAPTCHA_KEY || 'TEST'
  }
  if(process.env.CONTEXT === "branch-deploy") {
    return process.env.GATSBY_DEV_RECAPTCHA_KEY || 'TEST'
  }
  return process.env.GATSBY_RECAPTCHA_KEY
}


module.exports = {
  GetBuildStoryblokAccessToken,
  GetBridgeStoryblokAccessToken,
  GetBuildStoryblokVersion,
  GetRecaptchaKey
}